import { AlertTriangle } from 'lucide-react';
import { Outlet } from 'react-router-dom';
import Navigation from '../components/Navigation';
import { useAppContext } from '../contexts/AppContext';

export default function AppLayout() {
  const { state } = useAppContext();
  const { activeCall } = state;

  return (
    <div className="min-h-screen bg-gray-100">
      <Navigation />
      <main className="container mx-auto px-6 py-8">
        <Outlet />
      </main>

      {activeCall && activeCall.urgencyLevel === 'emergency' && (
        <div className="fixed bottom-4 right-4 bg-red-500 text-white p-4 rounded-lg shadow-lg animate-pulse">
          <div className="flex items-center space-x-2">
            <AlertTriangle className="w-5 h-5" />
            <span className="font-semibold">Emergency Call Active</span>
          </div>
        </div>
      )}
    </div>
  );
}
